import { ORANGE, ORANGE_BG } from "@/shared/constants.js";
import { labelBase } from "@/shared/utils/styles.js";

export const Field = ({ label, badge, children, style: extra }) => (
  <div style={{ marginBottom: 14, ...extra }}>
    <label style={labelBase}>
      {label}
      {badge && <span style={{ fontSize: 10, fontWeight: 500, color: ORANGE, background: ORANGE_BG, padding: "2px 8px", borderRadius: 10, marginLeft: 6, verticalAlign: "middle" }}>{badge}</span>}
    </label>
    {children}
  </div>
);
